import React, { FC } from 'react';
import styled from 'styled-components';
import { DrawerProps } from '../shared/types';
import DrawerHeader from '../DrawerHeader';
import DrawerBody from '../DrawerBody';
import DrawerFooter from '../DrawerFooter';

const DrawerContentContainer = styled.div`
  background-color: ${(props): string => props.theme.colors.primary.white};
  display: flex;
  flex-direction: column;
  max-width: 40rem;
  height: 100%;
  width: 100%;
`;

interface Props {
  title: DrawerProps['title'];
  cancelLabel: DrawerProps['cancelLabel'];
  submitLabel: DrawerProps['submitLabel'];
  cancelClick: DrawerProps['cancelClick'];
  submitClick: DrawerProps['submitClick'];
  renderAdditionalNavigationControls: DrawerProps['renderAdditionalNavigationControls'];
  children: DrawerProps['children'];
}

const DrawerContent: FC<Props> = ({
  title,
  cancelLabel,
  submitLabel,
  cancelClick,
  submitClick,
  renderAdditionalNavigationControls,
  children,
}) => {
  return (
    <DrawerContentContainer>
      <DrawerHeader title={title} submitClick={submitClick} />
      <DrawerBody submitClick={submitClick} renderAdditionalNavigationControls={renderAdditionalNavigationControls}>
        {children}
      </DrawerBody>
      <DrawerFooter
        cancelLabel={cancelLabel}
        submitLabel={submitLabel}
        cancelClick={cancelClick}
        submitClick={submitClick}
      />
    </DrawerContentContainer>
  );
};

export default DrawerContent;
